import { motion } from "framer-motion";

const STEPS = [
    { n: "01", t: "Consultation", d: "Understand your goals, constraints and timelines." },
    { n: "02", t: "Site Survey", d: "On-site assessment of infrastructure and RF conditions." },
    { n: "03", t: "Network Design", d: "L1–L7 architecture, capacity planning and BOQ." },
    { n: "04", t: "Product Recommendation", d: "Vendor-neutral selection matched to your workload." },
    { n: "05", t: "Quotation", d: "Transparent commercials with clear scope and terms." },
    { n: "06", t: "Installation", d: "Certified deployment with structured cabling and racking." },
    { n: "07", t: "Configuration", d: "Switching, routing, security and wireless configured to spec." },
    { n: "08", t: "Testing", d: "Link certification, penetration checks and load validation." },
    { n: "09", t: "Documentation", d: "Handover with diagrams, credentials and runbooks." },
    { n: "10", t: "AMC & Support", d: "Ongoing maintenance, monitoring and improvements." },
];

export default function Workflow() {
    return (
        <section id="workflow" className="py-20 lg:py-28 bg-white" data-testid="workflow-section">
            <div className="container-lg">
                <div className="max-w-2xl mb-14">
                    <span className="text-xs font-bold tracking-[0.24em] uppercase text-brand">Project Workflow</span>
                    <h2 className="mt-3 font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold text-navy">
                        A 10-step blueprint we&apos;ve refined over 500+ projects.
                    </h2>
                </div>

                <div className="relative">
                    <div className="absolute left-4 sm:left-6 top-2 bottom-2 w-px bg-gradient-to-b from-brand via-brand/30 to-transparent" />
                    <ol className="space-y-6">
                        {STEPS.map((s, i) => (
                            <motion.li
                                key={s.n}
                                initial={{ opacity: 0, x: -12 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                viewport={{ once: true, amount: 0.3 }}
                                transition={{ duration: 0.4, delay: i * 0.04 }}
                                data-testid={`workflow-step-${s.n}`}
                                className="relative pl-14 sm:pl-20"
                            >
                                <div className="absolute left-0 top-0 flex items-center justify-center w-9 h-9 sm:w-12 sm:h-12 rounded-full bg-navy text-white font-display font-bold text-sm sm:text-base shadow-md">
                                    {s.n}
                                </div>
                                <div className="rounded-2xl border border-slate-200 bg-white p-5 sm:p-6 hover:border-brand/30 hover:shadow-[0_10px_28px_rgba(10,37,64,0.05)] transition-[box-shadow,border-color]">
                                    <h3 className="font-display text-lg sm:text-xl font-semibold text-navy">{s.t}</h3>
                                    <p className="mt-1.5 text-slate-600 text-sm sm:text-base">{s.d}</p>
                                </div>
                            </motion.li>
                        ))}
                    </ol>
                </div>
            </div>
        </section>
    );
}
